import styles from './styles.module.css';

export default function ResultsLcaTool({ dict }) {
    // Извлекаем нужные поля из dict.discover
    const {
        results_lca_tool_1,
        results_lca_tool_2
    } = dict.discover;

    return (
        <section className={styles.results_lca_tool}>
            <p>{results_lca_tool_1}</p>
            <p>{results_lca_tool_2}</p>
        </section>
    );
}
